import { render, staticRenderFns } from "./LxDropdownButton.vue?vue&type=template&id=75044a1d&scoped=true"
import script from "./LxDropdownButton.vue?vue&type=script&lang=js"
export * from "./LxDropdownButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75044a1d",
  null
  
)

export default component.exports